export default __webpack_public_path__ + "static/media/combo-black.be7f7743.svg";